module.exports = __webpack_public_path__ + "img/vuesax-bulk-clipboard-tick.cfc309cc.svg";